// Keep deletion state separate from fetched messages: stale HTTP responses and
// delayed create/update broadcasts must never restore hidden or deleted content.
export function recordDeletion(ledger, event) {
  if (event?.message_id == null || !['me', 'everyone'].includes(event.scope)) return false;
  const key = String(event.message_id);
  const previous = ledger.get(key);
  ledger.set(key, previous?.scope === 'me' ? previous : event);
  return true;
}

export function reconcileDeletions(messages, ledger) {
  return messages.flatMap(message => {
    const deletion = ledger.get(String(message.id));
    if (deletion?.scope === 'me') return [];
    const deletedAt = message.deleted_at || (deletion?.scope === 'everyone' && deletion.deleted_at);
    if (!deletedAt) return [message];
    return [{ ...message, body: null, meta: null, uploads: [], reply_to_id: null, edited_at: null,
      deleted_at: deletedAt, can_delete_for_everyone: false }];
  });
}

export function mergeMessageLists(current, incoming, ledger) {
  const byId = new Map(current.map(message => [String(message.id), message]));
  incoming.forEach(message => {
    const previous = byId.get(String(message.id));
    // Delayed history and broadcasts must not undo an acknowledged edit.
    if (previous?.edited_at && !message.deleted_at &&
        Date.parse(previous.edited_at) > (message.edited_at ? Date.parse(message.edited_at) : 0)) return;
    byId.set(String(message.id), { ...previous, ...message,
      deleted_at: previous?.deleted_at || message.deleted_at });
  });
  return reconcileDeletions([...byId.values()], ledger).sort((a, b) =>
    (a.message_index ?? Number.MAX_SAFE_INTEGER) - (b.message_index ?? Number.MAX_SAFE_INTEGER));
}
